import { toRgba } from "./auth-service-tools213.js";

function rgba(color, alpha2) {
  if (typeof color !== "string" || alpha2 > 1 || alpha2 < 0) {
    return "rgba(0, 0, 0, 1)";
  }

  if (color.startsWith("var(")) {
    const mixPercentage = (1 - alpha2) * 100;
    return `color-mix(in srgb, ${color}, transparent ${mixPercentage}%)`;
  }

  if (color.startsWith("oklch")) {
    if (color.includes("/")) {
      return color.replace(/\/\s*[\d.]+\s*\)/, `/ ${alpha2})`);
    }

    return color.replace(")", ` / ${alpha2})`);
  }

  const {
    r,
    g,
    b
  } = toRgba(color);
  return `rgba(${r}, ${g}, ${b}, ${alpha2})`;
}

const alpha = rgba;
export { alpha, rgba };